// contact.js

const contactData = {
  title: "Send Us a Message",
  description:
    "Our team responds within 24 hours. Fill in your details and we'll be in touch.",

  heroHeading: "Let's Find Your Perfect Space",
  heroSub:
    "Have a property in mind? Our Madurai experts are ready to guide you every step of the way.",


  heroAvailability: "We're Available Now",   // ✅ added
  officeLabel: "Our Office — Madurai",       // ✅ added
  tagText: "✦ Contact Us",                  // ✅ added
  successMessage: "Your message was sent! We'll reach out shortly.", // ✅ added
  sendText: "Send Message",                 // ✅ added
  sentText: "Message Sent!",                // ✅ added
 infoItems: [                              // ✅ moved labels from JSX
    { key: "phone", label: "Call Us" },
    { key: "email", label: "Email Us" },
    { key: "address", label: "Visit Us" },
  ],

  stats: [
    { value: "500+", label: "Properties Listed" },
    { value: "12 Yrs", label: "Of Experience" },
    { value: "98%", label: "Client Satisfaction" },
  ],

  formFields: [
    { id: 1, name: "name",    placeholder: "John Doe",            label: "Your Name"     },
    { id: 2, name: "email",   placeholder: "you@email.com",       label: "Email Address" },
    { id: 3, name: "phone",   placeholder: "+91 00000 00000",     label: "Phone Number"  },
    { id: 4, name: "subject", placeholder: "Property Enquiry",    label: "Subject"       },
    { id: 5, name: "message", placeholder: "Tell us about the kind of property you're looking for...", label: "Your Message", type: "textarea" },
  ],

  contactInfo: {
    phone:   "+91 9500090493",
    email:   "mail.propertiesinfinite@gmail.com",
    address: "DRO Colony Main Rd, K.Pudur, Madurai, Tamil Nadu 625002",
  },

  image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80",
};

export default contactData;